/* eslint-disable */

import axios from 'axios'

const getUniversities = async (context) => {
  if (context.getters.isLoggedIn) {
    const payload = {
      headers: {
        Authorization: `JWT ${context.rootState.jwt.jwt}`
      }
    }

    await axios.get(context.state.endpoints.universities, payload)
      .then((response)=>{
        context.commit('setUniversities', response.data);
      })
      .catch((error)=>{
        console.log(error);
      })
  }
}

const setUniversity = (context, newUniversity) => {
  context.commit('setUniversity', newUniversity)
}

export default {
  getUniversities,
  setUniversity,
}